import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MdDashboard } from "react-icons/md";
import {
  API_BASE_URL,
  getJsonAuthHeaders,
  apiErrorMessage,
  SERVER_UNAVAILABLE_MESSAGE,
} from "../../../utils/api";
import "../../superadmin/CampusDashboard/CampusListView.css";

function FeeCampusSelectPage({ onLogout, showToast }) {
  const navigate = useNavigate();
  const [campuses, setCampuses] = useState([]);
  const [loading, setLoading] = useState(true);

  const onLogoutRef = useRef(onLogout);
  const showToastRef = useRef(showToast);
  onLogoutRef.current = onLogout;
  showToastRef.current = showToast;

  useEffect(() => {
    let cancelled = false;

    const loadCampuses = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/campuses`, {
          headers: getJsonAuthHeaders(),
        });
        if (res.status === 401) {
          onLogoutRef.current?.();
          return;
        }
        if (!res.ok) {
          throw new Error(apiErrorMessage(res, "Failed to load campuses"));
        }
        const data = await res.json();
        if (!cancelled) setCampuses(Array.isArray(data) ? data : []);
      } catch (error) {
        if (cancelled) return;
        console.error("Failed to load campuses", error);
        const message =
          String(error?.message || "").includes("Failed to fetch")
            ? SERVER_UNAVAILABLE_MESSAGE
            : error?.message || SERVER_UNAVAILABLE_MESSAGE;
        showToastRef.current?.("error", "Load Error", message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadCampuses();
    return () => { cancelled = true; };
  }, []);

  if (loading) {
    return (
      <div className="dashboard-content campus-management-page" style={{ padding: 24 }}>
        <h2 style={{ marginBottom: 16 }}>Select Campus</h2>
        <div style={{ color: "#64748b", fontSize: 13, fontWeight: 600 }}>Loading campuses...</div>
      </div>
    );
  }

  return (
    <div className="dashboard-content campus-management-page" style={{ padding: 24 }}>
      <h2 style={{ marginBottom: 16 }}>Select Campus</h2>

      <div className="campus-grid">
        {campuses.map((campus) => (
          <div
            key={campus.id}
            className="campus-card clickable"
            onClick={() => navigate(`/fees/campus/${campus.id}`)}
          >
            <div className="campus-card-header">
              <div className="campus-icon">
                <MdDashboard />
              </div>
              <h3>{campus.name}</h3>
            </div>
            <div className="campus-card-body">
              <p>
                <strong>Location:</strong> {campus.location || "N/A"}
              </p>
              <p>
                <strong>Principal:</strong> {campus.principal || "Not Assigned"}
              </p>
            </div>
          </div>
        ))}
      </div>

      {campuses.length === 0 && (
        <div className="viewer-empty-state">
          <h3>No campuses found</h3>
        </div>
      )}
    </div>
  );
}

export default FeeCampusSelectPage;
